import * as React from 'react';

import type { UStudioContextValue } from './types';
import { UStudioContext } from './UStudioContext';

export function useUStudio(): UStudioContextValue {
  const ctx = React.useContext(UStudioContext);
  if (!ctx) {
    throw new Error('useUStudio must be used within a UStudioProvider');
  }
  return ctx;
}
